import { useEffect, useState } from 'react';
import styles from './page.module.css';
import Card from "../../components/Card/Card";
import SportModul from "../../components/SportModul/SportModul";
import { fetchModulesByCategory } from '../../../code/SportModuleLoader';
import HeroBanner from '../../components/HeroBanner/HeroBanner';

function Gesundheitssport() {
    const [module, setModule] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasImages, setHasImages] = useState(false);


    useEffect(() => {
        setLoading(true);
        fetchModulesByCategory('reha', setModule);
        setLoading(false);
    }, []);

    if (loading) {
        return (<div></div>)
    }
    return (
        <div>
            <HeroBanner category="reha" onImagesLoaded={setHasImages} />
            <section className={styles.container} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}>
                <h1>Rehabilitation (Reha)</h1>
                <div className={styles.startText}>
                    <p>Bewegung, Spiel und Spaß – Rehasport ist eine vom Arzt verordnete gesetzliche Leistung und soll die körperliche Leistungsfähigkeit des Einzelnen in der Gruppengemeinschaft steigern bzw. zu einem selbstbestimmten Leben beitragen.< br />
                        Als gemeinnütziger Sportverein hat es sich der TuS 05 Oberpleis zur Aufgabe gesetzt, REHASPORT in den Fachrichtungen Orthopädie (Orthopädie und Aqua-Reha) und Herzsport (Kardiologie) anzubieten.<br /><br />
                        Ziel ist es, Ausdauer und Kraft zu steigern, Koordination und Flexibilität zu verbessern und das Selbstbewusstsein und die Einschätzung der körperlichen Belastbarkeit zu stärken. Außerdem soll mit diesen Kursen ein Level erreicht werden, dass sich die Teilnehmer darin bestärkt fühlen, in das daran anschließende (Vereins-)Sportangebote  einzusteigen, um die Ganzkörperfitness zu erhalten oder auszubauen.<br /><br />
                        Die sporttherapeutischen Kurse werden von qualifizierten REHASPORT B-Lizenz-Trainern geleitet. Der TuS 05 Oberpleis ist zertifizierter Leistungserbringer von Rehabilitations-Sport mit dem Deutschen Standard REHASPORT durch den Behinderten- und Rehabilitationssportverband NRW e.V.
                    </p>
                </div>
                <section>
                    <div className={styles.modulesContainer}>
                        {/* --- ALL cards come from the array -------------------------------- */}
                        {module.map((modul, index) => (
                            <Card
                                key={index}
                                id={modul.anchor_id}
                                icon={`${process.env.PUBLIC_URL}${modul.iconPath || modul.icon_path}`}
                                iconText={modul.iconText}
                                title={modul.title}
                                rightText={modul.class || ''}
                            >
                                <SportModul modul={modul} />
                            </Card>
                        ))}
                    </div>
                </section>
            </section>
        </div>
    )
}

export default Gesundheitssport;